import { Avatar, Card, Col, Layout, Row, Image } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import HubSidebar from "./sidebar";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const HubLayout = ({
  children,
  hubId,
}: {
  children: ReactElement;
  hubId: string;
}): ReactElement => {
  const { hubInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                size="small"
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content">
                      <div className="shop-banner">
                        <Image
                          src={getImgUrl(hubInfo?.image)}
                          alt={hubInfo?.name}
                          className="rounded"
                        />
                      </div>

                      <div className="shop-image-content">
                        <div className="shop-logo">
                          <Avatar size={105} src={getImgUrl(hubInfo?.image)} />
                        </div>
                        <div className="body">
                          <h4>
                            {hubInfo?.name?.toUpperCase()}
                            {/* <Badge>
                              {hubInfo?.deleted === true ? (
                                <FontAwesomeIcon
                                  icon={faCheckCircle}
                                  className="text-success ml-2"
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="text-danger ml-2"
                                />
                              )}
                            </Badge> */}
                          </h4>
                          <div className="mb-4">
                            <span className="radius-btn active-btn">
                              {hubInfo?.type?.replace("_", " ")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                <HubSidebar hubId={hubId} />
              </Card>
            </Col>
            <Col span={18}>
              <Card
                size="small"
                className="product-information-show-tab-wrapper"
              >
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

HubLayout.propType = {
  children: PropTypes.element,
};

export default HubLayout;
